/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {DeleteGrafanaReportConfigurationRequest} from "../model/delete-grafana-report-configuration-request";
import {GrafanaReportConfiguration} from "../model/grafana-report-configuration";

@Injectable({
    providedIn: "root",
})
export class SimGrafanaReportConfigurationService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
/**
 * Deletes a grafana report configuration.
 */ 

    public deleteGrafanaReportConfiguration(deleteGrafanaReportConfigurationRequest: DeleteGrafanaReportConfigurationRequest) {
        return super.post<void>(`/api/GrafanaReportConfiguration/DeleteGrafanaReportConfiguration`, deleteGrafanaReportConfigurationRequest);
    }
/**
 * Retrieves an GrafanaReportConfiguration object by its ID.
 */ 

    public getReportConfigurationById(reportConfigurationId: string) {
        return super.get<GrafanaReportConfiguration>(`/api/GrafanaReportConfiguration/GetReportConfigurationById`, {reportConfigurationId: reportConfigurationId});
    }
/**
 * Retrieves a list of Grafana Report Configurations.
 */ 

    public getReportConfigurations() {
        return super.get<GrafanaReportConfiguration[]>(`/api/GrafanaReportConfiguration/GetReportConfigurations`, );
    }
/**
 * Upserts an GrafanaReportConfiguration.
 */ 

    public upsertReportConfiguration(grafanaReportConfiguration: GrafanaReportConfiguration) {
        return super.post<void>(`/api/GrafanaReportConfiguration/UpsertReportConfiguration`, grafanaReportConfiguration);
    }
}